import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const token = localStorage.getItem('token');

        if (storedUser && token) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
                setIsAuthenticated(true);
            } catch (error) {
                console.error('Error parsing user from localStorage:', error);
                clearAuthData();
            }
        }
    }, []);

    // Helper function to clear all auth data
    const clearAuthData = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('userFullName');
        localStorage.removeItem('userPhone');
        localStorage.removeItem('userAddress');

        // Clear the cached profile picture
        localStorage.removeItem('profilePicture');

        // Clear sessionStorage if used
        sessionStorage.removeItem('profilePicture');

        // Dispatch event to notify other components about logout
        window.dispatchEvent(new Event('userLoggedOut'));
    };

    // Login function
    const login = (userData) => {
        setUser(userData);
        setIsAuthenticated(true);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    // Logout function
    const logout = () => {
        setUser(null);
        setIsAuthenticated(false);
        clearAuthData();
    };

    return (
        <AuthContext.Provider value={{
            user,
            isAuthenticated,
            login,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    );
};
